// extracted by mini-css-extract-plugin
var _1 = "TabAsset_group__4eee1";
var _2 = "TabAsset_items__ae654";
var _3 = "TabAsset_root__593cf";
export { _1 as "group", _2 as "items", _3 as "root" }
